export enum InfigoProductType {
    Normal = 10,
    Variable = 20,
    Static = 30,
    MultiPart = 40,
    Dynamic = 50,
    Sms = 60,
    Symphony = 70,
    Custom = 80,
}
